module.exports = __webpack_public_path__ + "static/media/Eliminar.16550d4d.svg";